import React from "react";
import PropTypes from "prop-types";

import moment from "moment";

import Controls from "./Controls";

const ChildItem = ({ item, crud, subTitle }) => {
	const getTimeAgo = sendAt => {
		const difference = moment(sendAt).diff(moment(), "weeks");
		if (Math.abs(difference) > 4) {
			return moment(sendAt).format("D MMM, YYYY");
		} else {
			return moment(sendAt).fromNow();
		}
	};

	const renderStatus = publishAt => {
		let style, text;
		if (publishAt) {
			if (moment(publishAt).diff(moment()) < 0) {
				style = "success";
				text = "Live";
			} else {
				style = "pending";
				text = `Publishes ${getTimeAgo(publishAt)}`;
			}
		} else {
			style = "draft";
			text = "Draft";
		}
		return <span className={`status ${style}`}>{text}</span>;
	};

	return (
		<div className="child-session">
			<div className="pull-right">
				<Controls id={item.id} crud={crud} title={item.title} isChild={true} />
			</div>
			<div className="child-session-content">
				<div className="child-item-title">
					{item.title && <h4>{item.title}</h4>}
					{renderStatus(item.publishAt || false)}
				</div>
				<div className="child-item-subtitle">{subTitle && <h6>{subTitle}</h6>}</div>
				<div className="react-tags">
					{item.tags &&
						item.tags.map(tag => (
							<div key={tag} className="react-tags__selected">
								<div className="react-tags__selected-tag">
									<span className="react-tags__selected-tag-name">{tag}</span>
								</div>
							</div>
						))}
				</div>
			</div>
		</div>
	);
};

ChildItem.propTypes = {
	crud: PropTypes.object,
	item: PropTypes.object,
	subTitle: PropTypes.string,
};

export default ChildItem;
